module.exports = __webpack_public_path__ + "img/icon_stock.6ea3edb9.png";